export const RSV_CMS_URL = import.meta.env.VITE_RSV_CMS_URL || window.RSV_CMS_URL;
export const RSV_FRONT_URL = import.meta.env.VITE_RSV_FRONT_URL || window.RSV_FRONT_URL;
export const RSV_ADMIN_URL = import.meta.env.VITE_RSV_ADMIN_URL || window.RSV_ADMIN_URL;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || window.SENTRY_ENVIRONMENT;
export const YANDEX_METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID || window.YANDEX_METRIKA_ID;
export const SENTRY_DSN = __SENTRY_DSN__ || null;
